import React from 'react';
import Header from './Header/Header';
import HeaderNavbar from './HeaderNavbar/HeaderNavbar';
import Footer from './Footer/Footer';
import classnames from 'classnames';

import './layout.scss';
import ProfilePopup from '../ProfilePopup/ProfilePopup';
import PopupNavigation from '../PopupNavigation/PopupNavigation';
import {connect} from "react-redux";

const Layout = ({children, invitation, narrow, colorBg, patternBg, noPadding, containerStyle, page = '', cardBorder}) => {

    let classContent = {
        'main-content': true,
        'pattern-bg': patternBg,
        'no-padding': noPadding,
        'main-card-border': cardBorder,
        'color-bg': colorBg
    };

    let classInner = {
        'main-content-inner': true,
        'narrow': narrow,
    };

    return (
        <>
            <Header/>
            {invitation && <HeaderNavbar/>}

            <div className={classnames([classContent, page])}>
                <div style={containerStyle} className={classnames(classInner)}>
                    {children}
                </div>
            </div>

            <ProfilePopup />

            {invitation && <PopupNavigation/>}
            {invitation && <Footer/>}
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    invitation: state.invitation.data,
});

export default connect(mapStateToProps)(Layout);
